import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="billing-profile-country-selector"
// On country change, updates the Turbo Frame src to reload the creation form
// with country-specific field labels and hints.
export default class extends Controller {
  static values = { formUrl: String }

  update(event) {
    const countryId = event.target.value
    const frame = document.getElementById("billing_profile_form_body")

    if (!countryId) {
      frame.removeAttribute("src")
      frame.innerHTML = ""
      return
    }

    const params = new URLSearchParams(window.location.search)
    params.set("country_id", countryId)
    frame.src = `${this.formUrlValue}?${params.toString()}`
  }
}
